import React, { Component } from 'react';
import { Button, Col, Row, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { SlSectionTitle, SlBusyIndicator, SlButton, SlFormEntryRow } from '../editors';
import { metadataService } from '../../_services';

export class ConfirmationView extends Component {
    static displayName = ConfirmationView.name;

    constructor(props) {
        super(props);
        this.state = { isWorking: false, sunLoanBranch : "" };
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    componentDidMount() {
        if (this.props.sunLoanBranchId) {
            this.setState({isWorking: true});
            metadataService.getBranch(this.props.sunLoanBranchId)
                .then(response => this.setState({ isWorking: false, sunLoanBranch: response.data }));
        }
        else {
            this.setState({ isWorking: false });
        }
      }

    handleSubmit(e) {
        e.preventDefault();

        this.props.onDone(); 
        
    }

    render() {
        return (
            <div className="Confirmation">
                <SlSectionTitle sectionName='RequestSent'/>
                {this.state.isBusy ?
                    <SlBusyIndicator visible={this.state.isBusy}  />
                    :
                    <div>
                        <Card>
                            <CardBody>
                                <SlFormEntryRow>
                                    <div dangerouslySetInnerHTML={{ __html: metadataService.getMessage("WhatToExpectGeneric") }} />
                                </SlFormEntryRow>
                            </CardBody>
                        </Card>
                        <div>
                            <div className="text-center">
                                <SlButton name='Done' onClick={this.handleSubmit}/>
                            </div>
                        </div>   
                    </div>
                }
            </div>
        );
    }
}
ConfirmationView.propTypes = {
    sunLoanBranchId : PropTypes.string, 
    onDone : PropTypes.func.isRequired 
};